'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dPolicy$002dCode$0024 from "./presto.types$-Policy-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$11() {
  this.bf5 = null;
  this.bf3 = null;
  this.bf4 = false;
  this.bf1 = null;
  this.bf2 = false;
  this.bf6 = false;
  this.bf7 = false;
  this.bf5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$11 as $c_Lpresto_PrestoRouter$$anon$11 };
$p = $c_Lpresto_PrestoRouter$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$11;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$11() {
}
export { $h_Lpresto_PrestoRouter$$anon$11 as $h_Lpresto_PrestoRouter$$anon$11 };
$h_Lpresto_PrestoRouter$$anon$11.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bf5;
});
$p.t = (function() {
  if ((!this.bf4)) {
    this.bf3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bf4 = true;
  }
  return this.bf3;
});
$p.ag = (function() {
  if ((!this.bf2)) {
    this.bf1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPolicy$002dCode$0024.$m_Lpresto_types$PolicyCode$().ae7(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bf2 = true;
  }
  return this.bf1;
});
$p.v = (function() {
  if ((!this.bf7)) {
    this.bf6 = false;
    this.bf7 = true;
  }
  return this.bf6;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$11, "presto.PrestoRouter$$anon$11", ({
  NG: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$11 as $d_Lpresto_PrestoRouter$$anon$11 };
//# sourceMappingURL=presto.-Presto-Router$$anon$11.js.map
